import { render, staticRenderFns } from "./ForumIcon.vue?vue&type=template&id=168aa380&"
import script from "./ForumIcon.vue?vue&type=script&lang=js&"
export * from "./ForumIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports